<template>
  <div class="error-list">
    <Message :closable="false" severity="error" v-if="errosPai">
      <p class="mt-3">{{ errosPai }}</p>
    </Message>
  </div>
</template>

<script>
export default {
  name: 'ErrorList',

  props: {
    erros: Array
  },

  data() {
    return {
      // erros: null
    };
  },

  created() {
    // this.$root.$on("error:show", err => {
    //   if (err.length) {
    //     this.erros = err;
    //     document.getElementById("topo").scrollIntoView({
    //       behavior: "smooth"
    //     });
    //   } else {
    //     this.erros = null;
    //   }
    // });
    // this.$root.$on("error:hide", () => {
    //   this.erros = null;
    // });
  },

  methods: {
    rolarPagina() {
      document.getElementById("topo").scrollIntoView({
        behavior: "smooth"
      });
    }
  },

  computed: {
    errosPai() {
      const erros = this.erros && this.erros.length ? this.erros : null;

      if (erros && erros.length) {
        this.rolarPagina();
      }

      return erros ? erros.join(' ') : null;
    }
  }
};
</script>

<style scoped>
</style>